<style lang="scss">
  @import './base.scss';
  @import './event-item.scss';
</style>
<template>
  <div class="event-item-wrap">
    <!-- 模块关系 -->
    <expr-frame
      v-if="eventsList.length"
      :relation="tempExpr.relation"
      @on-choice-relation="changeRelation"
    ></expr-frame>
    <div class="event-module-content">
      <div class="module-content-item-box"
        v-for="(item, index) in eventsList"
        :key="index"
      >
        <!-- 连接线：只有第一个和最后一个显示 -->
        <connect-line
          v-if="index === 0 || index === 4"
          background
          :endLine="index===4"
        ></connect-line>

        <!-- 循环项目：事件 -->
        <event-item
          :event-item="item"
          :item-index="index"
          :child-select-list="selectList"
          :child-in-load="listInLoad"
          :caller-type="callerType"
          :type-name="typeName"
          :item-length="eventsList.length"
          @delete-event-item="deleteItem"
          @compile-expr="getEventsExpr"
          @set-error-status="setErrorStatus"
        ></event-item>
      </div>

      <div class="module-item-button" v-if="eventsList.length < 5">
        <!-- 连接线：只有第一个和最后一个显示 -->
        <connect-line
          v-if="eventsList.length < 5"
          background
          btnLine
        ></connect-line>
        <Button
          :class="['add-event-btn', {'cant-add': cantAdd}]"
          ghost-tmp
          :disabled="cantAdd"
          @click="showEventItem"
        >{{$t('userGroupEvent.addBtn')}}</Button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import eventItem from './event-item';
import connectLine from './connecting-line';
import exprFrame from './expr-relation';
import util from '../../libs/util';
import bus from '../../libs/bus';

export default {
  components: {
    eventItem,
    connectLine,
    exprFrame,
  },
  props: {
    itemExpr: {
      type: Object,
      default() {},
    },
    oCallerType: String,
    backupData: Object,
  },
  data() {
    return {
      callerType: this.oCallerType,
      typeName: {  // 区分调用
        customevent: 'userGroupEvent',
        page_view: 'userGroupPage',
        launch_info: 'userBehavior.launch_info',
      },
      newEventItem: {
        eventId: '',
        allEvents: false, // 是否为所有标准事件选项
      }, // 新增加的事件表达式
      eventsList: [], // 选中事件列表
      selectList: [], // 备选事件列表
      listInLoad: true,
      errorTipIndex: -1,
      hasError: false, // 是否存在错误
      cantAdd: true, // 是否可以添加条件
      // 用于取消请求
      source: axios.CancelToken.source(),
    };
  },
  computed: {
    tempExpr() {
      return this.itemExpr;
    },
  },
  mounted() {
    // 初始化数据
    this.initData();
    bus.$on('on-usergroup-recover', () => {
      this.tempExpr = JSON.parse(JSON.stringify(this.backupData));
      this.initData();
    });

    // 请求列表可选数据
    this.fetchData();
    bus.$on('on-app-change', () => {
      this.fetchData();
    });
  },
  beforeDestroy() {
    bus.$off('on-app-change');
  },
  methods: {
    initData() {
      this.errorTipIndex = -1; // 初始化错误位置
      this.initRelation();
      this.analysisExpr();
      if (!this.eventsList.length) {
        this.showEventItem();
      }
    },
    initRelation() {
      this.tempExpr.relation = this.tempExpr.relation || '$and';
      this.tempExpr.detail = {};
      const detail = JSON.parse(JSON.stringify(this.backupData.detail));
      this.tempExpr.detail[this.callerType] = detail;
      this.tempExpr.expr = JSON.parse(JSON.stringify(this.backupData.expr));

      // 编辑状态初始化时，添加按钮可用
      if (this.tempExpr.expr.length) this.cantAdd = false;
    },
    fetchData() {
      if (!bus.productid || !bus.platform.length) return;

      if (this.callerType === 'page_view') {
        this.fetchPageList();
      } else if (this.callerType === 'customevent') {
        this.fetchEventList();
      }
    },
    fetchPageList() {
      util.ajax.post('/app/rest/data.json/query', {
        groupby: 'pagename',
        limit: 1000,
        metrics: ['pageview'],
        pageid: `pageInfo_${bus.token}`,
        conditions: {
          developerid: bus.developerid,
          platformid: bus.isAllPlatform ? '' : bus.platform.toString(),
          productid_list: [bus.productInfo.productid],
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        },
      })
        .then((data) => {
          this.getSelectList(data);
        });
    },
    fetchEventList() {
      const params = {
        platformid: bus.productInfo.platform.join(','),
        productid: bus.productid,
        begin: 0,
        count: 9999,
      };
      util.ajax.get('/app/rest/eventManager/getWhiteList', { params })
        .then((data) => {
          this.getSelectList(data);
        });
    },
    getSelectList(data) {
      const tempList = [];
      for (let i = 0, len = data.length; i < len; i += 1) {
        const item = data[i];
        if (this.callerType === 'customevent' && item.eventid) {
          const tempObj = {};
          tempObj.value = item.eventid;
          tempObj.label = item.displayname || item.eventid;
          tempObj.platformid = item.platformid;

          tempList.push(tempObj);
        }

        if (this.callerType === 'page_view' && item.pagename) {
          const tempObj = {};
          tempObj.value = item.pagename;
          tempObj.label = item.pagename;

          tempList.push(tempObj);
        }
      }
      this.selectList = tempList;
      this.listInLoad = false;
    },
    showEventItem() {
      const newItem = {
        id: '',
        displayname: '',
        allData: false, // 是否为所有标准事件选项
        timeflag: [],
        hasError: false,
      };
      this.eventsList.push(newItem);
      // 设置添加按钮不可用
      this.cantAdd = true;
    },
    // 解析返回的表达式
    analysisExpr() {
      const eventsExpr = this.tempExpr.expr;
      let name = '';

      if (this.callerType === 'customevent') {
        name = 'eventId';
      } else if (this.callerType === 'page_view') {
        name = 'pageName';
      }

      this.eventsList = [];
      eventsExpr.forEach((item) => {
        const tempItem = {};
        const outterObj = item[this.callerType];

        if (name && outterObj[name]) {
          const id = outterObj[name].$eq;
          // 解析id
          tempItem.id = id;
          tempItem.allData = id === 'allData';
        }
        tempItem.timeflag = outterObj.timeflag.$between;

        this.eventsList.push(tempItem);
      });
    },
    // 生成表达式和表达式文案
    generateExprList() {
      const eventsList = this.eventsList;
      const tempExpr = [];
      const tempDetail = {};
      const detailList = [];
      const triggerType = this.$t(`${this.typeName[this.callerType]}.userTrigger`);

      this.errorTipIndex = -1;
      const isRepeat = false;
      let hasError = false;

      for (let i = 0, len = eventsList.length; i < len; i += 1) {
        const item = eventsList[i];
        let detail = '';

        // 没有日期不做处理
        if (!isRepeat && item.timeflag.length) {
          const timeflag = JSON.parse(JSON.stringify(item.timeflag));
          if (timeflag.length === 1) timeflag.push(timeflag[0]);

          const time = timeflag.join(' ~ ');
          // 判断是否重复,若重复，派发重复事件且中断循环
          const repeat = this.verifyRepeat(i, this.callerType);
          if (repeat) {
            bus.$emit('item-repeat', this.callerType, this.errorTipIndex);
            return false;
          }

          // 设置错误状态
          if (item.hasError && !hasError) {
            hasError = item.hasError;
          }

          // 可增加条件按钮初始化
          this.cantAdd = false;

          // 生成事件详情表达式
          if (this.callerType === 'customevent' && item.id) {
            const displayName = this.getDisplayName(item);
            if (!repeat) {
              // 表达式
              tempExpr.push({
                customevent: {
                  eventId: {
                    $eq: item.id,
                  },
                  timeflag: {
                    $between: item.timeflag,
                  },
                },
              });

              // 表达式文案
              detail = `${time}${triggerType}${displayName}`;
            }// else { // sonarLint:never execute
            //   isRepeat = true;
            // }
          // 生成页面信息表达式
          } else if (this.callerType === 'page_view' && item.id) {
            const displayName = this.getDisplayName(item);

            if (!repeat) {
              // 表达式
              tempExpr.push({
                page_view: {
                  pageName: {
                    $eq: item.id,
                  },
                  timeflag: {
                    $between: timeflag,
                  },
                },
              });

              // 表达式文案
              detail = `${time}${triggerType}${displayName}`;
            } //else { // sonarLint:never execute
            //   isRepeat = true;
            // }
          // 生成活跃用户表达式
          } else if (this.callerType === 'launch_info') {
            if (!repeat) {
              tempExpr.push({
                launch_info: {
                  timeflag: {
                    $between: timeflag,
                  },
                },
              });

              // 表达式文案
              detail = `${time}${triggerType}`;
            } //else { // sonarLint:never execute
            //   isRepeat = true;
            // }
          } else {
            this.cantAdd = true;
          }

          // 如有重复，不可继续添加 // sonarLint:never execute
          // if (isRepeat) this.cantAdd = true;

          detailList.push(detail);
        } else {
          // 添加按钮不可用
          this.cantAdd = true;
        }
      }
      // return tempExpr;
      tempDetail[this.callerType] = detailList;

      return {
        expr: tempExpr,
        detail: tempDetail,
        errorStatus: isRepeat || hasError,
      };
    },
    // 设置显示label
    getDisplayName(data) {
      if (data.displayName) {
        return data.displayName;
      }
      for (let i = 0, len = this.selectList.length; i < len; i += 1) {
        const item = this.selectList[i];
        if (item.value === data.id) {
          return item.label;
        }
      }
      return '';
    },
    /**
     * [verifyRepeat 验证是否存在重复项]
     * @param  {[Numeber]} i    [当前项序号]
     * @param  {[String]} type [当前项类型，‘launch_info’不进行id判断]
     * @return {[Boolean]}      [是否重复]
     */
    verifyRepeat(i, type) {
      const eventsList = this.eventsList;
      const item = eventsList[i];
      for (let j = i + 1, l = eventsList.length; j < l; j += 1) {
        const oItem = eventsList[j];

        // 判断时间是否相等
        if (JSON.stringify(item.timeflag) === JSON.stringify(oItem.timeflag)) {
          // 时间相等，且为launch_info，判为重复
          if (type === 'launch_info') {
            this.errorTipIndex = j;
            return true;
          }

          // 时间相等，且不为launcher_info，判断id是否一致
          if (item.id === oItem.id) {
            this.errorTipIndex = j;
            return true;
          }
        }
      }

      // 时间不相等，判为不重复
      return false;
    },
    // 选择时间出错时，不编译表达式，设置错误状态
    setErrorStatus(status) {
      this.hasError = status;
      // 存在错误的情况下，给赋值
      if (status) this.tempExpr.errorStatus = status;
    },
    // 删除item
    deleteItem(index) {
      this.eventsList.splice(index, 1);
      // 删除后重新编译表达式
      this.getEventsExpr();
    },
    // 修改表达式关系
    changeRelation(type) {
      this.tempExpr.relation = type;
    },
    // setErrorStatus() {
    //   this.hasError = true;
    // },
    // 获取表达式
    getEventsExpr() {
      this.errorTipIndex = -1;
      const result = this.generateExprList();
      if (result) {
        this.tempExpr.expr = result.expr; // 表达式列表
        this.tempExpr.detail = result.detail;  // 文案列表
        // 是否存在错误的状态
        this.tempExpr.errorStatus = result.errorStatus || this.hasError;
      }
    },
  },
};
</script>
